"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountTray = void 0;
exports.default = AccountTrayWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _componentUtilities = require("@ux/component-utilities");
var _trayMenu = require("@ux/tray-menu");
var _enums = require("../enums");
var _reactMintl = require("@godaddy/react-mintl");
var _userDetails = _interopRequireDefault(require("./user-details"));
var _signIn = _interopRequireDefault(require("./sign-in"));
var _createAccount = _interopRequireDefault(require("./create-account"));
var _quickLinks = _interopRequireDefault(require("./quick-links"));
var _userCircle = _interopRequireDefault(require("@ux/icon/user-circle"));
var _headerUtil = require("@ux/header-util");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* jscs:disable requireSpacesInsideJsxExpressionContainers */

/**
 * Render and expose the AccountTray as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced AccountTray.
 * @api public
 */
class AccountTray extends _react.Component {
  /**
   * generates custom sso links for login and create account
   * @returns {Object} sso links
   */
  getSsoLinks() {
    const {
      sso,
      urls,
      privateLabelId,
      app
    } = this.props;
    let loginLink = urls.sso.login.href;
    let createAccountLink = urls.sso.createAccount.href;

    // Special handling for auctions app as they do not want to be handled by venture home - https://godaddy-corp.atlassian.net/browse/UXP-10659
    if (app === 'auctions') {
      let path = '/';
      if (typeof window !== 'undefined' && window.location && window.location.pathname) {
        path = window.location.pathname;
      }
      const ssoParams = {
        path,
        app: 'auctions'
      };
      loginLink = _headerUtil.url.updateQuery(loginLink, ssoParams);
      createAccountLink = _headerUtil.url.updateQuery(createAccountLink, ssoParams);
    } else if (privateLabelId === 1) {
      const ssoParams = {
        path: '/',
        app: 'venture-redirector'
      };
      loginLink = _headerUtil.url.updateQuery(loginLink, ssoParams);
      createAccountLink = _headerUtil.url.updateQuery(createAccountLink, ssoParams);
    }
    if (sso) {
      const {
        path,
        app
      } = sso;
      if (path) {
        loginLink = _headerUtil.url.updateQuery(loginLink, {
          path
        });
        createAccountLink = _headerUtil.url.updateQuery(createAccountLink, {
          path
        });
      }
      if (app) {
        loginLink = _headerUtil.url.updateQuery(loginLink, {
          app
        });
        createAccountLink = _headerUtil.url.updateQuery(createAccountLink, {
          app
        });
      }
    }
    return {
      createAccountLink,
      loginLink
    };
  }
  render() {
    const props = this.props;
    let name;
    if (!(0, _componentUtilities.isMobile)(props.breakpoint)) {
      if (props.loggedIn) {
        // props.displayName is the short name (e.g. "Jane").
        name = props.displayName;
      } else {
        name = /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
          id: _enums.golf.login
        });
      }
    }
    const trayName = /*#__PURE__*/_react.default.createElement("span", {
      className: "account-tray-name"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "user-icon"
    }, /*#__PURE__*/_react.default.createElement(_userCircle.default, null)), /*#__PURE__*/_react.default.createElement("span", {
      className: "title-text"
    }, name));
    const ssoLinks = this.getSsoLinks();
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayMenu, {
      type: "base",
      className: (0, _classnames.default)('account-tray', {
        'is-pro': props.loggedIn && props.isPro
      }),
      name: trayName,
      "data-eid": "uxp.hyd.shared.utility_bar.account_tray.click"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-user"
    }, /*#__PURE__*/_react.default.createElement(_userDetails.default, props), !props.loggedIn && /*#__PURE__*/_react.default.createElement("div", {
      className: "content-wrap content-wrap-logged-out"
    }, /*#__PURE__*/_react.default.createElement(_signIn.default, (0, _extends2.default)({}, props, ssoLinks)), /*#__PURE__*/_react.default.createElement(_createAccount.default, (0, _extends2.default)({}, props, ssoLinks)))), /*#__PURE__*/_react.default.createElement(_quickLinks.default, props))));
  }
}

/**
 * Default properties for account tray.
 *
 * @type {Object}
 * @api public
 */
exports.AccountTray = AccountTray;
AccountTray.defaultProps = {
  urls: {
    products: 'https://mya.godaddy.com',
    renewals: 'https://account.godaddy.com/billing?filter=expires&subFilter=90',
    account: 'https://account.godaddy.com',
    pro: 'https://pro.godaddy.com',
    manageDomains: 'https://dcc.godaddy.com',
    manageHosting: 'https://gateway.godaddy.com',
    sso: {
      o365Login: 'https://sso.godaddy.com',
      webmailLogin: 'https://email.godaddy.com',
      login: 'https://sso.godaddy.com?realm=idp&app=mya&path=',
      logout: 'https://sso.godaddy.com/logout?realm=idp',
      createAccount: 'https://sso.godaddy.com/account/create?realm=idp&app=www&path='
    }
  },
  market: 'en-US',
  loggedIn: false,
  isPro: false,
  privateLabelId: 1
};

/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */
AccountTray.propTypes = {
  oldBrand: _propTypes.default.bool,
  sso: _propTypes.default.object,
  urls: _propTypes.default.object.isRequired,
  loggedIn: _propTypes.default.bool,
  privateLabelId: _propTypes.default.number,
  name: _propTypes.default.string,
  displayName: _propTypes.default.string,
  shopperId: _propTypes.default.string,
  isPro: _propTypes.default.bool,
  market: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object.isRequired,
  vip: _propTypes.default.object,
  breakpoint: _propTypes.default.string.isRequired,
  app: _propTypes.default.string.isRequired
};
function AccountTrayWrapper(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(..._enums.breakpoints);
  return /*#__PURE__*/_react.default.createElement(AccountTray, (0, _extends2.default)({
    breakpoint: breakpoint
  }, props));
}